const categories = ["social", "personalization", "books"];

module.exports = categories;
